import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ResearchValue } from "../../../services/api/instances/researchApi/types";
import {
  createResearchReducerBuilder,
  getEventLogReducerBuilder,
  getResearchResultReducerBuilder,
} from "./reducers";
import { ResearchState } from "./types";

const initialState: ResearchState = {
  researchValue: null,
  isResearchingStart: false,
};

const researchSlice = createSlice({
  name: "research",
  initialState,
  reducers: {
    setResearchValue: (state, action: PayloadAction<ResearchValue | null>) => {
      state.researchValue = action.payload;
    },
    setIsResearchingStart: (state, action: PayloadAction<boolean>) => {
      state.isResearchingStart = action.payload;
    },
    clearResearchValue: (state) => {
      state.researchValue = {
        research_object: {
          result: null,
          event_log: null,
          run_id: null,
        },
      };
    },
  },
  extraReducers: (builder) => {
    createResearchReducerBuilder(builder);
    getEventLogReducerBuilder(builder);
    getResearchResultReducerBuilder(builder);
  },
});

export const researchReducers = researchSlice.reducer;
export const { setResearchValue, setIsResearchingStart, clearResearchValue } =
  researchSlice.actions;
